export default {
  namespaced: true,
  state: {
    type: "",
    text: "",
    icon: ""
  },
  getters: {
    popupInfo: state => state
  },
  mutations: {
    showSignInPopup(state, popupInfo = {}) {
      state.type = popupInfo.type
      state.text = popupInfo.text
      state.icon = popupInfo.icon
    },
    hideSignInPopup(state) {
      state.type = ""
    }
  }
}
